export default "__VITE_ASSET__D3xMwy$r__"